"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDriverAccessToAttorneySupport = exports.getDriverAnnualPrice = exports.getDriverPrice = void 0;

var _estatePlanning = require("../selectors/estate-planning");

var _drivers = require("../constants/drivers");

var _format = require("../utils/format");

/**
 * @module
 *
 * @description Education Loans driver configurations
 */

/**
 * Get the price driver.
 * @param {object} offer - The marketplace offer.
 * @return {object} - The annotation "quick fact" driver.
 */
var getDriverPrice = function getDriverPrice(offer) {
  return {
    id: 'price',
    label: 'Price (one-time)',
    value: (0, _estatePlanning.getPriceDetails)(offer) || (0, _format.formatValue)((0, _estatePlanning.getPrice)(offer), _drivers.FORMATS.CURRENCY, true),
    valueSize: _drivers.VALUE_SIZES.MEDIUM
  };
};
/**
 * Get the annual price driver.
 * @param {object} offer - The marketplace offer.
 * @return {object} - The annotation "quick fact" driver.
 */


exports.getDriverPrice = getDriverPrice;

var getDriverAnnualPrice = function getDriverAnnualPrice(offer) {
  return {
    id: 'annualPrice',
    label: 'Price (annual)',
    value: (0, _estatePlanning.getAnnualPriceDetails)(offer) || (0, _format.formatValue)((0, _estatePlanning.getAnnualPrice)(offer), _drivers.FORMATS.CURRENCY, true),
    valueSize: _drivers.VALUE_SIZES.MEDIUM
  };
};
/**
 * Get the AccessToAttorneySupport driver.
 * @param {object} offer - The marketplace offer.
 * @return {object} - The annotation "quick fact" driver.
 */


exports.getDriverAnnualPrice = getDriverAnnualPrice;

var getDriverAccessToAttorneySupport = function getDriverAccessToAttorneySupport(offer) {
  return {
    id: 'accessToAttorneySupport',
    label: 'Access to attorney support',
    value: (0, _estatePlanning.getAccessToAttorneySupport)(offer),
    valueSize: _drivers.VALUE_SIZES.MEDIUM
  };
};

exports.getDriverAccessToAttorneySupport = getDriverAccessToAttorneySupport;